import TransferUpahProduksiAsetApi from './TransferSubkonProduksiAsetApi';

export default TransferUpahProduksiAsetApi;
